module.exports = __webpack_public_path__ + "static/knitted-castle-8417509df0c83641bcb95d634f1de090.png";